import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ImpressumContent, DatenschutzContent } from "./Legal";

export const Footer = () => {
  const [open, setOpen] = useState(null);

  return (
    <footer className="bg-teal-950 py-10">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 px-5 sm:flex-row">
        <a href="#top" data-testid="footer-logo" className="flex items-center gap-2.5">
          <img
            src="/wokivo-logo.png"
            alt="Wokivo Logo"
            className="h-10 w-10 rounded-[24%]"
          />
        </a>
        <nav data-testid="footer-nav" className="flex items-center gap-5">
          <button
            type="button"
            data-testid="footer-impressum"
            onClick={() => setOpen("impressum")}
            className="text-sm font-semibold text-teal-100/70 transition-colors duration-200 hover:text-white"
          >
            Impressum
          </button>
          <button
            type="button"
            data-testid="footer-datenschutz"
            onClick={() => setOpen("datenschutz")}
            className="text-sm font-semibold text-teal-100/70 transition-colors duration-200 hover:text-white"
          >
            Datenschutz
          </button>
          <a
            href="#support"
            data-testid="footer-support"
            className="text-sm font-semibold text-teal-100/70 transition-colors duration-200 hover:text-white"
          >
            Support
          </a>
        </nav>
        <p data-testid="footer-copyright" className="text-xs text-teal-100/50">
          © {new Date().getFullYear()} Wokivo. Alle Rechte vorbehalten.
        </p>
      </div>

      <Dialog open={open === "impressum"} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent
          data-testid="impressum-dialog"
          className="max-h-[85vh] overflow-y-auto sm:max-w-lg"
        >
          <DialogHeader>
            <DialogTitle className="font-display text-2xl font-extrabold text-slate-900">
              Impressum
            </DialogTitle>
          </DialogHeader>
          <ImpressumContent />
        </DialogContent>
      </Dialog>

      <Dialog open={open === "datenschutz"} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent
          data-testid="datenschutz-dialog"
          className="max-h-[85vh] overflow-y-auto sm:max-w-lg"
        >
          <DialogHeader>
            <DialogTitle className="font-display text-2xl font-extrabold text-slate-900">
              Datenschutzerklärung
            </DialogTitle>
          </DialogHeader>
          <DatenschutzContent />
        </DialogContent>
      </Dialog>
    </footer>
  );
};
